(() => {
  'use strict';

  // splide
  const slides = document.getElementsByClassName('cm-top-splide');

  // 要素が存在する場合のみ初期化
  if (slides.length > 0) {
    // 各 cm-top-splide 要素に対して Splide を初期化
    Array.from(slides).forEach((slide) => {
      // スライドの数を確認
      const slideItems = slide.querySelectorAll('.splide__slide');
      const hasMultipleSlides = slideItems.length > 1;

      // data属性から値を取得
      const autoplay = slide.dataset.autoplay === 'true' && hasMultipleSlides;

      const rawInterval = slide.dataset.interval;
      const interval = (rawInterval !== undefined ? parseFloat(rawInterval) : 3) * 1000;

      const raw = slide.dataset.speed;
      const speed = (raw !== undefined ? parseFloat(raw) : 3) * 1000;

      let splide = new Splide(slide, {
        type: 'loop',
        perPage: 1,
        autoplay: autoplay,
        interval: interval,
        speed: speed,
        easing: 'ease',
        arrows: true,
        pagination: hasMultipleSlides,
        //rewind: true,
        pauseOnAction: false,
        pauseOnFocus: false,
        gap: '12px',
        fixedWidth: 960,
        focus: 'center',
        breakpoints: {
          960: {
            fixedWidth: '100%',
            gap: '0px',
          },
          768: {
            arrows: false,
          },
        },
      });

      // ===== ここから円形ローディング用の追記 =====
      // このスライダー専用のページネーションアイテム配列
      let paginationItems = [];

      // ページネーション生成時に、各ドットの中身を円形ローディングに差し替える
      splide.on('pagination:mounted', (data) => {
        if (!hasMultipleSlides) return;

        paginationItems = data.items;

        data.items.forEach((item) => {
          const btn = item.button;

          // SVG 構造変更：内側の円(inner-dot)を追加
          //中心点：cx = W/2、cy = H/2
          //半径：r=（W/2）− (stroke幅/2)
          btn.innerHTML = `
            <svg class="pagination-ring" viewBox="0 0 36 36">
              <!-- 内側の塗りつぶし円（デザイン） -->
              <circle class="inner-dot" cx="18" cy="18" r="6"></circle>

              <!-- 背景リング -->
              <circle class="ring-bg" cx="18" cy="18" r="16"></circle>

              <!-- 進捗リング -->
              <circle class="ring-fg" cx="18" cy="18" r="16"></circle>
            </svg>`;

          const fg = btn.querySelector('.ring-fg');

          // 外側リングは r = 16
          const radius = 16;
          const circumference = 2 * Math.PI * radius;

          fg.style.strokeDasharray = `${circumference}`;
          fg.style.strokeDashoffset = `${circumference}`;
          fg.dataset.circumference = circumference;
        });
      });

      // autoplay の進行度（0〜1）に応じて、アクティブなドットの円だけ埋めていく
      splide.on('autoplay:playing', (rate) => {
        if (!paginationItems.length) return;

        const activeIndex = splide.index;

        paginationItems.forEach((item, i) => {
          const fg = item.button.querySelector('.ring-fg');
          if (!fg) return;

          const circumference = parseFloat(fg.dataset.circumference);

          if (i === activeIndex) {
            // rate = 0 → dashoffset = circumference（0%）
            // rate = 1 → dashoffset = 0（100%）
            fg.style.strokeDashoffset = circumference * (1 - rate);
          } else {
            // 非アクティブなドットはリセット（常に 0% に戻す）
            fg.style.strokeDashoffset = circumference;
          }
        });
      });
      // ===== 円形ローディング追記ここまで =====

      /* splide.on('pagination:mounted', (data) => {
        const paginationEl = data.list; // これが生成されたUL
        const wrapper = document.querySelector('.splideBtnWrapper');
        wrapper.prepend(paginationEl);
      }); */

      splide.mount();

      // スライドが1つの場合は play_btn を非表示
      /* if (!hasMultipleSlides) {
        const playBtn = slide.querySelector('.play_btn');
        if (playBtn) {
          playBtn.style.display = 'none';
        }
      } */
    });
  }
})();
